module.exports = __webpack_public_path__ + "a577bd5906764f0ae9cf588e552f51f9.pdf";